import React from 'react';

export const AdminVendedoresMetrics = ({ metrics }) => {
  if (!metrics) {
    return null;
  }

  const mediaLeads = metrics.total_leads > 0 && metrics.vendedores_ativos > 0
    ? (metrics.total_leads / metrics.vendedores_ativos).toFixed(1)
    : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8" data-testid="admin-vendedores-metrics-grid">
      <div className="bg-white rounded-xl shadow p-6" data-testid="admin-vendedores-total-vendedores-card">
        <div className="text-3xl font-bold text-blue-600" data-testid="admin-vendedores-total-vendedores-value">{metrics.total_vendedores}</div>
        <div className="text-gray-600">Total Vendedores</div>
      </div>
      <div className="bg-white rounded-xl shadow p-6" data-testid="admin-vendedores-ativos-card">
        <div className="text-3xl font-bold text-green-600" data-testid="admin-vendedores-ativos-value">{metrics.vendedores_ativos}</div>
        <div className="text-gray-600">Vendedores Ativos</div>
      </div>
      <div className="bg-white rounded-xl shadow p-6" data-testid="admin-vendedores-total-leads-card">
        <div className="text-3xl font-bold text-purple-600" data-testid="admin-vendedores-total-leads-value">{metrics.total_leads}</div>
        <div className="text-gray-600">Total de Leads</div>
      </div>
      <div className="bg-white rounded-xl shadow p-6" data-testid="admin-vendedores-media-card">
        <div className="text-3xl font-bold text-orange-600" data-testid="admin-vendedores-media-value">{mediaLeads}</div>
        <div className="text-gray-600">Média Leads/Vendedor</div>
      </div>
    </div>
  );
};
